<div style="padding: 30px;">
    <div *ngIf="!resumeUploadSuccess">
            <p class="disclaimer-text">Note: When uploading a resume (only PDF format is accepted, with a maximum limit of three pages), your profile will be updated as a batch process on the 3rd of each month. If you upload your resume after the 3rd, your changes will be reflected in the following month’s update.<br>Uploading a new resume will replace your current profile details.</p>
        <div *ngIf="activeUpload">
            <nz-upload nzType="drag" [nzShowUploadList]="false" [nzMultiple]="false" [nzAccept]="'application/pdf'"
                (nzChange)="onFileSelected($event)">

                <p class="ant-upload-drag-icon">
                    <span nz-icon nzType="inbox"></span>
                </p>
                <div style="margin: 5px;">
                    <p class="ant-upload-text">Click to upload resume</p>
                    <p class="ant-upload-hint">
                        Upload resume in PDF format and maximum three pages are allowed</p>
                </div>
            </nz-upload>
        </div>
        <div class="loader-overlay" *ngIf="isLoader">
            <div class="loader-backdrop"></div>
            <nz-spin nzTip="Loading..." [nzSize]="'large'" class="loader-spinner">
                <nz-alert nzType="info"></nz-alert>
            </nz-spin>
        </div>
        <div *ngIf="selectedFileName" class="file-view">
            <span nz-icon nzType="file"></span>
            {{ selectedFileName }}&nbsp;&nbsp;
            <i nz-icon nzType="delete" nzTheme="outline"
                style="color: red; cursor: pointer; margin-left: 8px; font-size: 20px;" (click)="removeFile()"></i>
        </div>
        <div *ngIf="selectedFile">
            <p class="success-design-text" style="color: green;">This document contains {{resumePagecount}} pages.
            </p>
        </div>
        <div *ngIf="uploadMessage" style="margin-top: 5px; color: rgb(255, 0, 0);">
            {{ uploadMessage }}
        </div>
        <button nz-button nzType="primary" style="margin-top: 15px; " [disabled]="uploading || !selectedFile"
            (click)="uploadResume()">
            Upload Resume
        </button>
    </div>
    <div *ngIf="resumeUploadSuccess" class="popup-content">
        <p class="success-design-text">
            <i nz-icon nzType="check-circle" nzTheme="outline"
                style="color: rgb(98, 239, 5); cursor: pointer; margin-left: 8px; font-size: 20px;"></i> 
                Resume added successfully! </p>
        <button nz-button nzType="primary" style="margin-top: 15px;" (click)="closePopup()">Close</button>
    </div>

</div>